<template>
    <!-- <pagebreadcrumb :title="title" :text="text" :text1="text1" /> -->
    <div class="banner">
        <div class="text-white" style="width:420px;z-index: 5;text-align:center;position:absolute;left: 50%;margin-left:-210px;top:70px;">
            <h2 class="text-white" style="font-size:50px">Ofertas Laborales</h2>
            <h4 class="text-white" style="font-size:20px"><router-link to="/" class="text-white">Inicio</router-link> / Ofertas Laborales</h4>
        </div>
    </div>

    <div class="banner-kofe" style="position:absolute; width: 100%; width: 600px; top:140px; left: 50%; margin-left: -300px;">
        <div class="banner-content aos text-center" data-aos="fade-up" data-aos-duration="1000">
            <form @submit.prevent="searchOffers" class="form mt-5" name="store" id="store" method="post" action="project">
                <div class="form-inner">
                    <div class="input-group">
                        <span class="drop-detail">
                            <vue-select :options="Projects" id="projectsone" placeholder="Puesto" />
                        </span>
                        <input type="text" class="form-control" placeholder="Busqueda por palabra clave ..." v-model="search_query">
                        <button class="btn btn-agv sub-btn-agv" type="submit">Buscar </button>
                    </div>
                </div>
            </form>
        </div>
    </div>


    <!-- Page Content -->
    <div class="content">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-4 col-xl-3 theiaStickySidebar">
            <div class="stickysidebar">
              <div class="card search-filter">
                <div class="card-header d-flex justify-content-between">
                    <h4 class="card-title mb-0 text-white" style="font-size:17px">Seleccionar:</h4>
                </div>
              </div>
              <div class="card-body">
                  <div class="filter-widget" style="margin-top: -35px;">
                      <h4 class="filter-title">
                          <a href="javascript:void(0);" class="w-100" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                              Puesto	
                              <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                          </a> 
                      </h4>
                      <div id="collapseOne" class="collapse show" data-bs-parent="#accordionExample1" >
                          <div @click.stop>
                              <label class="custom_check">
                                  <input type="checkbox" name="select_time" v-model="selected_positions" value="auxiliar">
                                  <span class="checkmark"></span> Auxiliar
                              </label>
                          </div>
                          <div @click.stop>
                              <label class="custom_check">
                                  <input type="checkbox" name="select_time" v-model="selected_positions" value="asistente">
                                  <span class="checkmark"></span> Asistente
                              </label>
                          </div>
                          <div @click.stop>
                              <label class="custom_check">
                                  <input type="checkbox" name="select_time" v-model="selected_positions" value="analista">
                                  <span class="checkmark"></span> Analista
                              </label>
                          </div>
                          <div @click.stop>
                              <label class="custom_check">
                                  <input type="checkbox" name="select_time" v-model="selected_positions" value="supervisor">
                                  <span class="checkmark"></span> Supervisor
                              </label>
                          </div>
                          <div @click.stop>
                              <label class="custom_check">
                                  <input type="checkbox" name="select_time" v-model="selected_positions" value="coordinador">
                                  <span class="checkmark"></span> Coordinador
                              </label>
                          </div>
                      </div>
                  </div>
                  <div class="filter-widget" style="margin-top: -15px;">
                      <h4 class="filter-title">
                          <a href="javascript:void(0);" class="w-100" data-bs-toggle="collapse" data-bs-target="#collapseskills" aria-expanded="true" aria-controls="collapseOne">
                              Lugar
                              <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                          </a> 
                      </h4>
                      <div id="collapseskills" class="collapse show" data-bs-parent="#accordionExample1" >
                          <div @click.stop>
                              <label class="custom_check">
                                  <input type="checkbox" name="select_time"  v-model="selected_places" value="Lima">
                                  <span class="checkmark"></span> Lima
                              </label>
                          </div>
                          <div @click.stop>
                              <label class="custom_check">
                                  <input type="checkbox" name="select_time" v-model="selected_places" value="Chiclayo">
                                  <span class="checkmark"></span> Chiclayo	
                              </label>
                          </div>
                          <div @click.stop>
                              <label class="custom_check">
                                  <input type="checkbox" name="select_time" v-model="selected_places" value="Olmos">
                                  <span class="checkmark"></span> Olmos
                              </label>
                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-md-6">
                          <button type="button" class="btn btn-agv-dos" style="width:100%;border-radius:5px;font-size:14px;text-align:center" @click="localFilter">Buscar</button>
                      </div>
                      <div class="col-md-6">
                          <button type="button" class="btn btn-block" style="width:100%;border-radius:5px;font-size:14px;text-align:center"  @click="clearFilters">Limpiar</button>
                      </div>
                  </div>	
              </div>
            </div>
          </div>
  
          <div class="col-md-12 col-lg-8 col-xl-9">
            <div class="sort-tab develop-list-select">
              <div class="row align-items-center">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                  <div class="d-flex align-items-center">
                    <div class="freelance-view">
                      <!-- <h3>Se encontraron resultados</h3> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
    
            <div class="row">
              <!-- Project Content -->
              <div
                class="col-xl-4 col-md-6"
                v-for="record in filtered_job_offers"
                :key="record.id"
              >
                <div class="freelance-widget widget-author position-relative">
                  <div class="freelance-content">
                    <div class="freelance-location freelance-time" >
                      <i class="feather-clock me-1"></i> Publicado {{ record.created_date }}
                    </div>
                    <!-- <a data-bs-toggle="modal" href="#rating" class="favourite"
                      ><i class="feather-heart"></i
                    ></a> -->
                    <div class="author-heading">
                      <div class="freelance-img">
                        <a href="javascript:void(0);">
                          <!-- <img
                            :src="require(`@/assets/img/company/${record.Image}`)"
                            alt="author"
                          /> -->
                          <img 
                          v-if="record.s3_url" 
                          :src="record.s3_url" 
                          :alt="'Img ' + index" 
                          class="img-fluid" 
                          style="width: 100%;"
                          >
                          <img
                          v-if="!record.s3_url"
                          :src="require(`@/assets/img/agv_logo.jpg`)"
                          alt="author"
                          />
                          <span class="verified"><i class="fas fa-check-circle"></i></span>
                        </a>
                      </div>
                      <div class="profile-name" style="height: 80px;">
                        <div class="author-location">{{ record.work_pos }}</div>
                      </div>
                      <div class="freelance-info">
                        <!-- <h3>
                          <a href="javascript:void(0);">{{ record.Ui }}</a>
                        </h3> -->
                        <div class="freelance-location">
                          <img
                            :src="require(`@/assets/img/icon/locations.svg`)"
                            alt="img"
                            style="margin-right: 5px;"
                          />{{ record.place }}
                        </div>
                      </div>
                      <div class="freelance-tags">
                        <!-- <a href="javascript:void(0);"
                          ><span class="badge badge-pill badge-design me-1">{{
                            record.Html
                          }}</span></a
                        >
                        <a href="javascript:void(0);"
                          ><span class="badge badge-pill badge-design me-1">{{
                            record.React
                          }}</span></a
                        > -->
                        <a href="javascript:void(0);"
                          ><span class="badge badge-pill badge-design me-1">{{
                            record.n_vacancy
                          }} vacantes</span></a
                        >
                      </div>
                      <!-- <div class="freelancers-price">{{ record.Amount }}</div> -->
                    </div>
                    <!-- <div class="counter-stats">
                      <ul>
                        <li>
                          <h5>{{ record.Date }}</h5>
                          <h3 class="counter-value">{{ record.Days }}</h3>
                        </li>
                        <li>
                          <h5>{{ record.Proposal }}</h5>
                          <h3 class="counter-value">{{ record.cost }}</h3>
                        </li>
                        <li>
                          <h5>{{ record.job }}</h5>
                          <h3 class="counter-value">
                            <span class="jobtype">{{ record.jobtype }}</span>
                          </h3>
                        </li>
                      </ul>
                    </div> -->
                  </div>
                  <div class="cart-hover">
                    <router-link 
                    :to="{ path: '/detalle_oferta', query: { id: record.id } }" 
                    class="btn-cart" 
                    tabindex="-1"
                    >
                    <!-- to="/detalle_oferta"  -->
                      Ver más
                    </router-link
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-12">
                <ul class="paginations list-pagination">
                  <li class="page-item">
                    <a href="javascript:void(0);"><i class="feather-chevron-left"></i></a>
                  </li>
                  <li class="page-item">
                    <a href="javascript:void(0);" class="active">1</a>
                  </li>
                  <li class="page-item"><a href="javascript:void(0);">2</a></li>
                  <li class="page-item">
                    <a href="javascript:void(0);"><i class="feather-chevron-right"></i></a>
                  </li>
                </ul>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->
    <projectmodal></projectmodal>

    <!-- Pie de Página -->
    <footeragv></footeragv>
</template>
<script>
import axiosIns from '@/plugins/axios.js';
import { ref } from "vue";
export default {
props: {
  offerId: {
    type: Number,
    required: true
  }
},
data() {
    return {
      search_word: null,

      filtered_job_offers: [],
      all_job_offers: [],
      selected_positions: [], 
      selected_places: [], 
      search_query: '',

      searchOptions: ["Puesto", "Lugar"],
      // filtered_job_offers: [
      //     {
      //         "id": 1,
      //         "Posted":" Posted Just Now",
      //         "Image":"img-1.png",
      //         "Amaze":"Asistente de Almacén",
      //         "Ui":"UI/UX Developer",
      //         "Image1": "locations.svg",
      //         "location":"Olmos, Lambayeque",
      //         // "Html":"HTML",
      //         // "React":"React",
      //         "Php":"2 vacantes",
      //         "Amount":"$40-$500",
      //         "Date":"Expiry",
      //         "Days":"4 Days Left",
      //         "Proposal":"Proposals",
      //         "cost":"15",
      //         "job":"Job Type",
      //         "jobtype":"Full Time"

      //     },
      // ],
      // title: "Project Grid",
      // text: "Home",
      // text1: "Projects",
      // Rating: ["Sort by (Default)", "Relevance", "Rating", "Popular", "Latest", "Free"],
      // Rating: ["Ordenar por", "Relevance", "Rating", "Popular", "Latest", "Free"],
    };


},
created(){
  this.search_query = this.$route.query.search_word;
},
mounted(){
  this.getJobOffers();
},
methods: {
  getJobOffers(){
    const yo = this
    const config = {
      method: 'get',
      url: '/talentoagv/readJobOffers/',
    }

    if(this.$store.getters.currentAdminLanguage == 'es'){
      yo.language = '1'
    }
    else if(this.$store.getters.currentAdminLanguage == 'en'){
      yo.language = '2'
    }

    axiosIns(config)
      .then(function (response) {
        console.log(response.data['result'])
        if (response.data['is_error'] === false){
            let resultado = response.data['result']
            for(let r of resultado){
                let fullName = r['name'] + ' ' + r['first_surname'] + ' ' + r['second_surname'];
                r['fullname'] = fullName; 
            }
            yo.filtered_job_offers = resultado
            yo.all_job_offers = resultado

            if(yo.search_query){
              console.log("SI VIENE 1 VALOR")
              yo.searchOffers()
            }
        }
      })
      .catch(function (error) {
        console.log(error);
        // yo.$toastr.error(response.data['message'], 'Error')
      })
      .finally(function (){
        
      })
  },
  localFilter(){
    this.filtered_job_offers = this.all_job_offers.filter(offer => {
        const matchesWorkPos = this.selected_positions.length === 0 || this.selected_positions.some(pos => offer.work_pos.toLowerCase().includes(pos.toLowerCase()));
        const matchesPlace = this.selected_places.length === 0 || this.selected_places.some(place => offer.place.toLowerCase().includes(place.toLowerCase()));
        return matchesWorkPos && matchesPlace;
    });
  },

  clearFilters() {
    this.selected_positions = [];
    this.selected_places = [];
    this.filtered_job_offers = this.all_job_offers;
  },
  
  searchOffers() {

    console.log("QUE FUE MANO")
    const query = this.search_query.toLowerCase();
    this.filtered_job_offers = this.all_job_offers.filter(offer => {
      return (this.selected_positions.length === 0 || this.selected_positions.some(pos => offer.work_pos.toLowerCase().includes(pos.toLowerCase())))
        && (this.selected_places.length === 0 || this.selected_places.some(place => offer.place.toLowerCase().includes(place.toLowerCase())))
        && (offer.work_pos.toLowerCase().includes(query) || offer.place.toLowerCase().includes(query));
    });
  },
},

};
</script>
<style>
    .banner{
        width: 100%;
        height: 550px;
        background-image: url('../../../../assets/talento_agv/img/FundoA9.png') !important;
        background-size: cover !important;
        background-position: center bottom;
    }

    .banner::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 550px;
        background-color: rgba(0, 0, 0, 0.4); /* Color negro semi-transparente */
    }

    .titulo{
        position: absolute;
        top:-100px;
        left: 50%;
        margin-left: -220px;
        z-index: 5;
    }
</style>
  